<template>
	<div class="contentpdf">
		<headerbar :curindex="1"></headerbar>
		<!-- <div class="centerpage"><p class="page-guide"><router-link to="/macro-background" target="_blank">宏观背景</router-link> >{{title}}</p></div> -->
	 <div class="contentpdf_ifrm">
			<!-- <embed :src="file" width="100%" height="100%"></embed> -->
			 <iframe :src="file" width="100%" height="100%"></iframe>
		</div> 
		<!-- <footerbar></footerbar> -->
	</div>
</template> 
<script> 
	export default {
	  name: 'pdfdetail',
	  data(){return{
				msg:"资讯详情页",
				pagetypes:1,
				curindex:10,
				newsid:415611,
				hotlist:[],
				file:"", 
				pageextend:{policyDecode:[],policySource:[]},
				pagedata:{star:0,content:"",notion:'',publishTime:"",},
				title:"", 
			}},  
		created() { 
				this.getuserinfor(); 
				this.getpagelist();
				// this.gethottopic()
			},
			mounted() { 	},
			methods:{
				//公用部分
				getuserinfor(){
					this.bus.$emit('loading',true);
					let dataddd=sessionStorage.getItem('userData') ? sessionStorage.getItem('userData'):localStorage.getItem('userData') ;
					if(typeof(dataddd) == 'object'){
					this.userdata = dataddd;
					}else{
					this.userdata = JSON.parse(dataddd);
					}
					this.newsid=this.$route.query.id*1;   
				},
				getpagelist(){
					var _this=this;
					this.$axios.get(this.$api.cyl.news.detail()+'?id='+this.newsid,{headers:{AuthToken:this.userdata.token}}).then(function(res){
						// 11-9 稍微有点数据
						console.log(res.data,res.data.data.file);
						_this.pagedata=res.data.data;  
						_this.file=res.data.data.file; 
						document.title=res.data.data.title;
						_this.title=res.data.data.title; 
						_this.bus.$emit('loading',false);
					}) 
				},  
		} 
	}
	
	
	
</script>

<style scoped="scoped">  

</style>   
